export default {
  lang: 'zh',
  file: {
    wangEditor: {
      插入: '插入',
      默认: '默认',
      创建: '创建',
      修改: '修改',
      如: '如',
      请输入正文: '',
      menus: {
        title: {
          标题: '标题',
          加粗: '加粗',
          字号: '字号',
          字体: '字体',
          斜体: '斜体',
          下划线: '下划线',
          删除线: '删除线',
          缩进: '缩进',
          行高: '行高',
          文字颜色: '文字颜色',
          背景色: '背景色',
          链接: '链接',
          序列: '序列',
          对齐: '对齐',
          引用: '引用',
          表情: '表情',
          图片: '图片',
          视频: '视频',
          表格: '表格',
          代码: '代码',
          分割线: '分割线',
          恢复: '恢复',
          撤销: '撤销',
          全屏: '全屏',
          代办事项: '代办事项'
        },
        dropListMenu: {
          设置标题: '设置标题',
          背景颜色: '背景颜色',
          文字颜色: '文字颜色',
          设置字号: '设置字号',
          设置字体: '设置字体',
          设置缩进: '设置缩进',
          对齐方式: '对齐方式',
          设置行高: '设置行高',
          序列: '序列',
          head: {
            正文: '正文'
          },
          indent: {
            增加缩进: '增加缩进',
            减少缩进: '减少缩进'
          },
          justify: {
            靠左: '靠左',
            居中: '居中',
            靠右: '靠右'
          },
          list: {
            无序列表: '无序列表',
            有序列表: '有序列表'
          }
        },
        panelMenus: {
          emoticon: {
            默认: '默认',
            新浪: '新浪',
            emoji: 'emoji',
            手势: '手势'
          },
          image: {
            图片链接: '图片链接',
            上传图片: '上传图片',
            网络图片: '网络图片'
          },
          link: {
            链接: '链接',
            链接文字: '链接文字',
            删除链接: '删除链接',
            查看链接: '查看链接'
          },
          video: {
            插入视频: '插入视频'
          },
          table: {
            行: '行',
            列: '列',
            的: '的',
            表格: '表格',
            添加行: '添加行',
            删除行: '删除行',
            添加列: '添加列',
            删除列: '删除列',
            设置表头: '设置表头',
            取消表头: '取消表头',
            插入表格: '插入表格',
            删除表格: '删除表格'
          },
          code: {
            删除代码: '删除代码',
            修改代码: '修改代码',
            插入代码: '插入代码'
          }
        }
      },
      validate: {
        张图片: '张图片',
        大于: '大于',
        图片链接: '图片链接',
        不是图片: '不是图片',
        返回结果: '返回结果',
        上传图片超时: '上传图片超时',
        上传图片错误: '上传图片错误',
        上传图片失败: '上传图片失败',
        插入图片错误: '插入图片错误',
        一次最多上传: '一次最多上传',
        下载链接失败: '下载链接失败',
        图片验证未通过: '图片验证未通过',
        服务器返回状态: '服务器返回状态',
        上传图片返回结果错误: '上传图片返回结果错误',
        请替换为支持的图片类型: '请替换为支持的图片类型',
        您插入的网络图片无法识别: '您插入的网络图片无法识别',
        您刚才插入的图片链接未通过编辑器校验: '您刚才插入的图片链接未通过编辑器校验'
      }
    }
  }
};